import React from "react";
import { string } from "prop-types";
import { Col } from "react-bootstrap";
import checkCircle from "resources/images/check-circle-light-blue.svg";

const FeatureOverview = ({ title, text }) => (
  <Col sm={6} md={6} lg={6} className="d-flex">
    <img
      src={checkCircle}
      height="12px"
      width="12px"
      alt="check circle"
      style={{ marginRight: "10px" }}
      className="mt-1"
    />
    <div>
      <div style={{ color: "#202d63", fontWeight: "bold" }}>{title}</div>
      <p style={{ paddingRight: "10px" }}>{text}</p>
    </div>
  </Col>
);

FeatureOverview.propTypes = {
  title: string,
  text: string,
};

export default FeatureOverview;
